<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :persistenceKey="'customer-delivery-address-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import {
  CustomerTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/customer/customer-tabs";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {};
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Customers",
        selectedIndex: GetIndexByTabName("Delivery Addresses"),
        tabs: CustomerTabs,
        exportFileName: "Delivery Addresses List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerDeliveryAddressList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            // rowSelect: {
            //   view: this,
            //   page: "sales-order",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Delivery Addresses",
                // message: "Get Started, Add a Customer",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            filterOnEnter: true,
            // customButtons: [
            //   {
            //     icon: "plus",
            //     label: "Add New",
            //     route: "/customer/create",
            //     clickAction: {},
            //     buttonLocation: "left",
            //   },
            // ],
          },
          columns: [
            {
              screenField: "Customer",
              filterIndex: 1,
              fixed: true,
              fixedPosition: "left",
              allowHiding: false,
            },
            {
              screenField: "DeliveryCompany",
              dataField: "CompanyName",
              label: "Delivery Name",
              filterDataField: "CompanyName",
              filterIndex: 0,
              dataType: "string",
              type: "Text",
            },
            {
              screenField: "PhysicalAddressStreetLine1",
            },
            {
              screenField: "PhysicalAddressStreetLine2",
            },
            {
              screenField: "PhysicalAddressSuburb",
            },
            {
              screenField: "State",
              filterIndex: 5,
            },
            {
              screenField: "Country",
              filterIndex: 6,
            },
            {
              screenField: "Region",
              dataField: "RegionCode",
              filterDataField: "RegionCode",
              filterIndex: 3,
            },
            {
              screenField: "SubRegion",
              gridDataField: "SubregionCode",
              filterDataField: "SubregionCode",
              cellTemplate: false,
              cellTemplateRecord: false,
              exportFields: false,
              filterIndex: 4,
            },
            {
              screenField: "DropCode",
              dataField: "DropCode",
              filterDataField: "DropCode",
              filterIndex: 2,
            },
            {
              screenField: "DeliveryCompany",
              dataField: "SelfReference",
              label: "Delivery Self Ref",
            },
            {
              screenField: "Status",
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    goToCredit(e) {
      this.$router.push({
        path: `credit-customer/create/${e.Code}`,
      });
    },
  },

  created() {},
};
</script>

<style lang="scss"></style>
